<template>
    <div class="user-contact-history">
      <h2>用户历史联系信息管理</h2>
  
      <el-table
        :data="contactList"
        style="width: 100%"
      
        stripe
        v-loading="loading"
      >
        <el-table-column prop="name" label="姓名" width="120" />
        <el-table-column prop="company" label="公司" width="200" />
        <el-table-column prop="email" label="邮箱" width="200" />
        <el-table-column prop="phone" label="电话" width="150" />
        <el-table-column prop="message" label="留言内容" />
        <el-table-column prop="contact_time" label="联系时间" width="180" />
        <el-table-column label="处理状态" width="120">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.is_processed ? 'success' : 'warning'"
              @click="toggleProcessed(scope.row)"
              style="cursor: pointer"
            >
              {{ scope.row.is_processed ? '已处理' : '未处理' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="deleteContact(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
  
      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px; text-align: right"
        background
        layout="prev, pager, next, total"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </div>
  </template>
  
  <script>
  import {
    getUserContactHistory,
    deleteUserContact,
    updateUserContactStatus
  } from "@/api/userContact"; // 你需要在 api 里封装这些接口
  
  export default {
    name: "UserContactHistory",
    data() {
      return {
        contactList: [],
        page: 1,
        pageSize: 10,
        total: 0,
        loading: false
      };
    },
    methods: {
      async fetchContacts() {
        this.loading = true;
        try {
          const res = await getUserContactHistory({
            page: this.page,
            pageSize: this.pageSize
          });
          if (res.data.status === 200) {
            this.contactList = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg || "获取数据失败");
          }
        } catch (error) {
          console.error("获取历史联系信息异常:", error);
          this.$message.error("请求异常，请稍后重试");
        } finally {
          this.loading = false;
        }
      },
  
      async deleteContact(id) {
        this.$confirm("确定要删除这条记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(async () => {
          try {
            const res = await deleteUserContact({ id });
            if (res.data.status === 200) {
              this.$message.success("删除成功");
              this.fetchContacts();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          } catch (error) {
            console.error("删除异常:", error);
            this.$message.error("删除异常，请稍后重试");
          }
        });
      },
  
      async toggleProcessed(row) {
        try {
          const res = await updateUserContactStatus({
            id: row.id,
            is_processed: !row.is_processed
          });
          if (res.data.status === 200) {
            this.$message.success("状态更新成功");
            this.fetchContacts();
          } else {
            this.$message.error(res.data.msg || "状态更新失败");
          }
        } catch (error) {
          console.error("状态更新异常:", error);
          this.$message.error("操作异常，请稍后重试");
        }
      },
  
      handlePageChange(newPage) {
        this.page = newPage;
        this.fetchContacts();
      }
    },
    mounted() {
      this.fetchContacts();
    }
  };
  </script>
  
  <style scoped>
  .user-contact-history {
    padding: 20px;
  }
  </style>
  